<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 mt-2  ">
        <h4 class="text-center">Terms & Details</h4>
      </div>
      <div class="col-12">
        <div class="row my-3">
          <div class="col-6 text-center">
            <button
              class="btn btn-primary "
              @click="setLang('en')"
              style="min-width: 200px;">
              English
            </button>
          </div>
          <div class="col-6 text-center">
            <button
              class="btn btn-primary"
              @click="setLang('fr')"
              style="min-width: 200px;">
              Français
            </button>
          </div>
        </div>
        <!-- English -->
        <div v-if="lang == 'en'">
          <span
            class="badge bg-info"
            style="font-size: 20px;">
            Florida Show for attendees only
          </span>
          <div>
            <ul>
              <li>Order dates</li>
              <ul>
                <li>January 26 to February 5, 2026</li>
              </ul>
            </ul>
            <ul>
              <li>Shipping</li>
              <ul>
                <li>Option A - February 16 to March 6, 2026</li>
                <li>Option B - March 16 to April 3, 2026</li>
              </ul>
            </ul>
            <ul>
              <li>Payment terms</li>
              <li>Standard terms apply</li>
            </ul>
            <ul>
              <li>Pre-Show Orders</li>
              <ul>
                <li>Customers who place show orders within the Lancaster’s eStore show portal are still eligible to earn spiffs and prize points based on these orders.</li>
                <li>You must attend the Orlando event in person to be eligible.</li>
                <li>Please stop by the registration desk to print your official pre-show order report, then present this report to each vendor that is represented on it to cash in. The report summarizes qualifying items for spiffs and prizes, making it easier for vendors to verify when you visit their booths.</li>
                <li>Orders placed after the show are not eligible for additional spiffs or prize points.</li>
                <li>Orders submitted through the eStore during the show may take up to 5 minutes to appear on your pre-order report.</li>
              </ul>
            </ul>
            <ul>
              <li>Spiffs</li>
              <ul>
                <li>Spiffs are cash incentives from exhibitors for your purchases (e.g., $1 per gallon). When visiting their booths, exhibitors will complete and sign your spiff sheets, including spiff earned for your pre-show orders. Spiffs can be claimed at the Lancaster Bank so please allow extra time after making your purchases to visit the bank. You can choose either cash or credit, based on your Lancaster credit standing.</li>
              </ul>
            </ul>
            <ul>
              <li>Travel Reimbursement</li>
              <ul>
                <li>
                  Purchases of $8,000 USD or more qualify for a travel reimbursement equal to 3% of your show purchases (up to $750 USD per ship-to location). Please use the reimbursement forms provided in your registration packet or on the Lancaster eStore and either e-mail marketing@lancasterco.com or mail to Attn: Marketing, 1310 Union Street, Spartanburg, SC 29302
                </li>
              </ul>
            </ul>
            <ul>
              <li>Lodging Reimbursement</li>
              <ul>
                <li>Purchases of $8,000 - $9,999 USD - One Night Reimbursed*</li>
                <li>Purchases of $10,000+ USD - Two Nights Reimbursed*</li>
                <li>(*Room, tax and resort fee, based on the group rate.)</li>
              </ul>
            </ul>
          </div>
          <hr>
          <div>
            <span
              class="badge bg-info"
              style="font-size: 20px;">
              Virtual Show only
            </span>
          
            <ul>
              <li>Order dates</li>
              <ul>
                <li>February 9 to March 13, 2026</li>
              </ul>
            </ul>
            <ul>
              <li>Placing orders</li>
              <ul>
                <li>You may place orders at www.lancasterco.com or by emailing customer.serviceca@lancasterco.com.</li>
              </ul>
            </ul>
            <ul>
              <li>Minimum order value</li>
              <ul>
                <li>$1,500 minimum with unlimited buys</li>
              </ul>
            </ul>
            <ul>
              <li>Shipping deadline</li>
              <ul>
                <li>April 3, 2026 (Backorders and open orders will be cancelled thereafter)</li>
              </ul>
            </ul>
            <ul>
              <li>Payment terms</li>
              <ul>
                <li>Standard terms apply</li>
              </ul>
            </ul>
            <ul>
              <li>Shipping</li>
              <ul>
                <li>Standard prepaid minimums apply</li>
              </ul>
              <li>No spiffs available</li>
            </ul>
          </div>
        </div>
        <!-- French -->
        <div v-if="lang == 'fr'">
          <span
            class="badge bg-info"
            style="font-size: 20px;">
            Salon de Floride réservé aux participants
          </span>
          <ul>
            <li>Dates de commande</li>
            <ul>
              <li>Du 26 janvier au 5 février 2026</li>
            </ul>
          </ul>
          <ul>
            <li>Expédition</li>
            <ul>
              <li>Option A - Du 16 février au 6 mars 2026</li>
              <li>Option B - Du 16 mars au 3 avril 2026</li>
            </ul>
          </ul>
          <ul>
            <li>Conditions de paiement</li>
            <ul>
              <li>Les conditions standard s'appliquent</li>
            </ul>
          </ul>
          <ul>
            <li>Commandes pré-salon</li>
            <ul>
              <li>Les clients qui passent des commandes de salon via le portail de salon eStore de Lancaster sont toujours éligibles pour gagner des primes et des points de prix en fonction de ces commandes.</li>
              <li>Vous devez assister à l'événement d'Orlando en personne pour être éligible.</li>
              <li>Veuillez vous arrêter au bureau d'inscription pour imprimer votre rapport de commande officiel avant le salon, puis présenter ce rapport à chaque vendeur qui y est représenté pour encaisser. Le rapport résume les articles éligibles aux primes et aux prix, ce qui facilite la vérification par les fournisseurs lorsque vous visitez leurs stands.</li>
              <li>Les commandes passées après le salon ne sont pas éligibles à des primes supplémentaires ou à des points de prix.</li>
              <li>Les commandes soumises via l'eStore pendant le salon peuvent prendre jusqu'à 5 minutes pour apparaître sur votre rapport de précommande.</li>
            </ul>
          </ul>
          <ul>
            <li>Spiffs</li>
            <ul>
              <li>Les spiffs sont des incitations en espèces des exposants pour vos achats (par exemple, 1 $ par gallon). Lors de votre visite à leurs stands, les exposants rempliront et signeront vos feuilles de spiff, y compris les spiffs gagnés pour vos commandes pré-salon. Les spiffs peuvent être réclamés à la Banque de Lancaster, alors veuillez prévoir du temps supplémentaire après vos achats pour visiter la banque. Vous pouvez choisir soit de l'argent liquide, soit un crédit, en fonction de votre solvabilité à Lancaster.</li>
            </ul>
            <li>Remboursement de voyage</li>
            <ul>
              <li>Les achats de 8 000 USD ou plus donnent droit à un remboursement de voyage égal à 3 % de vos achats au salon (jusqu'à 750 USD par lieu de livraison). Veuillez utiliser les formulaires de remboursement fournis dans votre dossier d'inscription ou sur le Lancaster eStore et soit envoyer un e-mail à marketing@lancasterco.com, soit envoyer par courrier à l'attention de : Marketing, 1310 Union Street, Spartanburg, SC 29302</li>
            </ul>
          </ul>
          <ul>
            <li>Remboursement de l'hébergement</li>
            <ul>
              <li>Achats de 8 000 à 9 999 USD - Une nuit remboursée*</li>
              <li>Achats de 10 000 USD et plus - Deux nuits remboursées*</li>
              <li>(*Chambre, taxe et frais de séjour, basés sur le tarif de groupe.)</li>
            </ul>
          </ul>
          <hr>
          <span
            class="badge bg-info"
            style="font-size: 20px;">
            Spectacle virtuel uniquement
          </span>
          <ul>
            <li>Dates de commande</li>
            <ul>
              <li>Du 9 février au 13 mars 2026</li>
            </ul>
          </ul>
          <ul>
            <li>Passer des commandes</li>
            <ul>
              <li>Vous pouvez passer des commandes sur www.lancasterco.com ou en envoyant un e-mail à customer.serviceca@lancasterco.com.</li>
            </ul>
          </ul>
          <ul>
            <li>Valeur minimale de commande</li>
            <ul>
              <li>1 500 $ minimum avec des achats illimités</li>
            </ul>
          </ul>
          <ul>
            <li>Date limite d'expédition</li>
            <ul>
              <li>3 avril 2026 (Les commandes en attente et les commandes ouvertes seront annulées par la suite)</li>
            </ul>
          </ul>
          <ul>
            <li>Conditions de paiement</li>
            <ul>
              <li>Les conditions standard s'appliquent</li>
            </ul>
          </ul>
          <ul>
            <li>Expédition</li>
            <ul>
              <li>Les minimums prépayés standard s'appliquent.</li>
            </ul>
          </ul>
          <ul>
            <li>Aucune prime disponible</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  // Initialize  
  const lang = ref('en')

  // Methods
  const setLang = (l)=>{
    lang.value = l
  }

</script>

<style scoped>
  ul{
    line-height: 2em;
  }
</style>